import React, { useState, useEffect } from "react"
import { TextField, Box } from "@material-ui/core"
import { useMutationCreateGroup } from "../../data"
import { useFormUtils } from "../../utils"
import { CreatorActions, CreatorMaster } from "../Creators"

const initialState = {
  title: "",
  description: "",
}

const GroupCreator = ({ open, onClose, edit, cy = "GroupCreator" }) => {
  const { isValid } = useFormUtils()
  const [createGroup, { loading: createGroupLoading }] = useMutationCreateGroup()

  const [name, setName] = useState(initialState.name)
  const [description, setDescription] = useState(initialState.description)

  const isEdit = edit != null

  useEffect(() => {
    if (edit) {
      setName(edit.name)
      setDescription(edit.description)
    }
  }, [edit, setName, setDescription])

  const handleCancel = () => {
    handleClose(false)
  }

  const handleClose = (updated) => {
    handleResetState()
    if (onClose) onClose(updated)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (formValid()) {
      if (isEdit) {
        // updateGroup({ variables: { id: edit.id, name, description } })
      } else {
        await createGroup({ variables: { name, description } })
      }
      handleClose(true)
    }
  }

  const handleResetState = () => {
    setName(initialState.name)
    setDescription(initialState.description)
  }

  const formValid = () => isValid(name)

  const isFormValid = formValid()

  const form = (
    <>
      <Box mb={1}>
        <TextField
          variant="outlined"
          fullWidth
          id="name"
          label="Name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          required
          inputProps={{ "data-cy": `${cy}-TextField-name` }}
        />
      </Box>
      {/* <Box mb={1}>
        <TextField
          variant="outlined"
          fullWidth
          id="description"
          label="Description"
          name="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          minRows={4}
          inputProps={{ "data-cy": `${cy}-TextField-description` }}
        />
      </Box> */}

      <CreatorActions
        id="GroupCreator-CreatorActions"
        subject="Area of Work"
        submitLoading={createGroupLoading}
        onClose={handleCancel}
        onSubmit={handleSubmit}
        disableSubmit={!isFormValid}
      />
    </>
  )

  return <CreatorMaster open={open} subject="Area of Work" form={form} isEdit={isEdit} onClose={handleCancel} />
}

export { GroupCreator }
